export function slug(s) { return (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "x"; }

// Canonical accounts-pack sections in default order, then re-ordered per `order` and flagged by `hidden`.
export function buildSections(acc, order = [], hidden = []) {
    const base = [
        { key: "ma", label: "Managing Agent's Report" },
        { key: "primary", label: acc.is_audit ? "Independent Auditor's Report" : "Report of Factual Findings" },
        { key: "is", label: "Service Charge Income & Expenditure Account" },
        ...((acc.income_statement?.per_schedule) || []).map((b) => ({ key: `is-${slug(b.schedule)}`, label: `Income & Expenditure — ${b.schedule}` })),
        { key: "bs", label: "Service Charge Balance Sheet" },
        { key: "notes", label: "Notes to the Service Charge Accounts" },
    ];
    const idx = (k) => { const i = order.indexOf(k); return i < 0 ? 999 : i; };
    return base
        .map((s, i) => ({ ...s, _i: i }))
        .sort((a, b) => (idx(a.key) - idx(b.key)) || (a._i - b._i))
        .map((s) => ({ key: s.key, label: s.label, hidden: (hidden || []).includes(s.key) }));
}
